import wow from 'wowjs'

/**
 * WOW.js.
 * Animate elements as they are scrolled into view
 * Don't forget to include https://github.com/daneden/animate.css
 * Instantiates only after the user starts scrolling as to 
 * not hide the elements from Googlebot.
 *
 * https://github.com/matthieua/WOW
 */
var scrolled = false
window.addEventListener('scroll', () => {
  if (!scrolled) {
    scrolled = true
    new wow.WOW().init()
  }
})

// Replace wow.js with just animate.css from any elements that are already
// in the browser window on load, so that they're not hidden until scroll.
setTimeout(() => {
  document.querySelectorAll('.wow').forEach(wow => {
    if (wow.getBoundingClientRect().top < window.innerHeight) {
      wow.classList.add('animated')
      wow.classList.remove('wow')
    }
  })
}, 100)

// Banner subjects.
const subjects = window.culligan.subjects || []
const headlineSubject = document.querySelector('.headline__subject')
let curSubject = 0

headlineSubject.innerHTML = subjects[curSubject]
curSubject++

setInterval(() => {
  headlineSubject.classList.add('no-opacity')

  setTimeout(() => {
    headlineSubject.innerHTML = subjects[curSubject]
    headlineSubject.classList.remove('no-opacity')

    curSubject++

    if (curSubject > subjects.length - 1) {
      curSubject = 0
    }
  }, 300)
}, 2500)
